import { render, staticRenderFns } from "./ItemPopover.vue?vue&type=template&id=43357896&scoped=true&"
import script from "./ItemPopover.vue?vue&type=script&lang=js&"
export * from "./ItemPopover.vue?vue&type=script&lang=js&"
import style0 from "./ItemPopover.vue?vue&type=style&index=0&id=43357896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43357896",
  null
  
)

export default component.exports